export class CalculatorData {
    public proValue: number;
    public fatValue: number;
    public carValue: number;
    public targetValue: number;
    public coefPhysActivity: number;
    public isMen: number;
    public age: number;
    public height: number;
    public weight: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/calculator-data.ts